export { CustomNamesTabsModule } from './custom-names-tabs.module';
export { CustomNamesService } from './services/custom-names.service';
export { CustomNamesPipe } from './pipes/custom-names.pipe';
export * from './types';
